import { Link } from 'react-router-dom';
import { Shield, Github, Twitter } from 'lucide-react';
import styles from './Footer.module.css';

export default function Footer() {
	const currentYear = new Date().getFullYear();

	return (
		<footer className={styles.footer}>
			<div className={styles.container}>
				<div className={styles.content}>
					<div className={styles.brand}>
						<Link to="/" className={styles.logo}>
							<Shield className={styles.logoIcon} />
							<span className={styles.logoText}>Ringfort Studio</span>
						</Link>
						<p className={styles.tagline}>
							Enterprise-grade crypto gaming infrastructure for operators worldwide.
						</p>
						<div className={styles.social}>
							<a
								href="https://github.com/ringfort-studio"
								target="_blank"
								rel="noopener noreferrer"
								className={styles.socialLink}
								aria-label="GitHub"
							>
								<Github size={20} />
							</a>
							<a
								href="https://twitter.com/ringfortstudio"
								target="_blank"
								rel="noopener noreferrer"
								className={styles.socialLink}
								aria-label="Twitter"
							>
								<Twitter size={20} />
							</a>
						</div>
					</div>

					<div className={styles.links}>
						<div className={styles.linkGroup}>
							<h4 className={styles.linkGroupTitle}>Product</h4>
							<ul className={styles.linkList}>
								<li>
									<Link to="/docs" className={styles.link}>
										Documentation
									</Link>
								</li>
								<li>
									<Link to="/docs/quickstart" className={styles.link}>
										Quick Start
									</Link>
								</li>
								<li>
									<Link to="/docs/api-operators" className={styles.link}>
										API Reference
									</Link>
								</li>
								<li>
									<Link to="/docs/provably-fair" className={styles.link}>
										Provably Fair
									</Link>
								</li>
							</ul>
						</div>

						<div className={styles.linkGroup}>
							<h4 className={styles.linkGroupTitle}>Games</h4>
							<ul className={styles.linkList}>
								<li>
									<Link to="/docs/games-dice" className={styles.link}>
										Dice
									</Link>
								</li>
								<li>
									<Link to="/docs/games-plinko" className={styles.link}>
										Plinko
									</Link>
								</li>
								<li>
									<Link to="/docs/games-coinflip" className={styles.link}>
										Coin Flip
									</Link>
								</li>
								<li>
									<Link to="/docs/games-crash" className={styles.link}>
										Crash
									</Link>
								</li>
							</ul>
						</div>

						<div className={styles.linkGroup}>
							<h4 className={styles.linkGroupTitle}>Developers</h4>
							<ul className={styles.linkList}>
								<li>
									<Link to="/docs/integration-guide" className={styles.link}>
										Integration Guide
									</Link>
								</li>
								<li>
									<Link to="/docs/wallet-modes" className={styles.link}>
										Wallet Modes
									</Link>
								</li>
								<li>
									<Link to="/docs/webhooks" className={styles.link}>
										Webhooks
									</Link>
								</li>
								<li>
									<Link to="/docs/testing-guide" className={styles.link}>
										Testing Guide
									</Link>
								</li>
							</ul>
						</div>

						<div className={styles.linkGroup}>
							<h4 className={styles.linkGroupTitle}>Platform</h4>
							<ul className={styles.linkList}>
								<li>
									<a
										href="https://play.rngfort.com"
										target="_blank"
										rel="noopener noreferrer"
										className={styles.link}
									>
										Demo Games
									</a>
								</li>
								<li>
									<a
										href="https://admin.rngfort.com"
										target="_blank"
										rel="noopener noreferrer"
										className={styles.link}
									>
										Admin Dashboard
									</a>
								</li>
								<li>
									<a
										href="https://operator.rngfort.com"
										target="_blank"
										rel="noopener noreferrer"
										className={styles.link}
									>
										Operator Dashboard
									</a>
								</li>
							</ul>
						</div>

						<div className={styles.linkGroup}>
							<h4 className={styles.linkGroupTitle}>Company</h4>
							<ul className={styles.linkList}>
								<li>
									<a href="mailto:hello@ringfort.studio" className={styles.link}>
										Contact
									</a>
								</li>
								<li>
									<a href="mailto:support@ringfort.studio" className={styles.link}>
										Support
									</a>
								</li>
								<li>
									<Link to="/privacy" className={styles.link}>
										Privacy Policy
									</Link>
								</li>
								<li>
									<Link to="/terms" className={styles.link}>
										Terms of Service
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div className={styles.bottom}>
					<p className={styles.copyright}>
						&copy; {currentYear} Ringfort Studio. All rights reserved.
					</p>
					<p className={styles.legal}>
						Ringfort Studio provides B2B gaming infrastructure. We do not operate consumer-facing gambling services.
					</p>
				</div>
			</div>
		</footer>
	);
}
